module.exports = __webpack_public_path__ + "static/img/jay.5e698f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jay.png
// module id = Hk2S
// module chunks = 1